import EgyszeruKerdesTableService from 'app/admin/egyszerukerdes/service/EgyszeruKerdesTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import TableChangeStatusButton from '../../kerdes/component/TableChangeStatusButton';
import TableQuestionViewButton from '../../kerdes/component/TableQuestionViewButton';

const config = {
	key: 'egyszeruKerdesTable',
	text: 'Egszerű kérdés',
	textKey: 'question',
	service: EgyszeruKerdesTableService,
	icon: 'person',
	editFormState: item => `/egyszerukerdes/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	// rowEndAction: ['subPage', 'modify'],
	// rowClick: item => `/valasz/${item.id}`,
	// subPage: {
	// 	state: '/valasz/',
	// 	tooltip: 'Tartalom'
	// },
	filterFields: [
		{
			propertyName: 'csorszam',
			propertyType: 'String',
			type: 'LIKE'
		},
		{
			propertyName: 'feladatCsoport',
			propertyType: 'Long',
			type: 'IN'
		},
		{
			propertyName: 'fejezet',
			propertyType: 'Long',
			type: 'IN'
		}
	],
	rowButtonList: [
		{
			key: 'questionView',
			component: TableQuestionViewButton
		},
		{
			key: 'changeStatus',
			component: TableChangeStatusButton
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'leirasPlaintext',
			text: 'Leírás',
			textKey: 'leirasPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'magyarazatPlaintext',
			text: 'Magyarázat',
			textKey: 'magyarazatPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function EgyszeruKerdesTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('egyszeruKerdesTable', reducer('egyszeruKerdesTable'))(EgyszeruKerdesTable);
